module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/black_hills_national_forest-80284187b5f62340626a4ea24b6bc713.jpg";